// CategoryGroup.js
import { connect } from 'react-redux';

import CategoryGroup from '../component/CategoryGroup.jsx';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';

const mapStateToProps = (state, { groupName = '' }) => {
  const categoryItems = getRemoteConfigData(
    state,
    `MESSAGE_CATEGORY_GROUPING_${groupName.toUpperCase()}`
  );

  return { categoryItems };
};

export default connect(mapStateToProps)(CategoryGroup);
